const d3 = Object.assign(
    {},
    require("d3-selection"),
    require("d3-array"),
    require("d3-scale"),
    require("d3-shape"),
    require("d3-brush")
)

import "lodash"

export function createBrush() {
    const xAccessor = d => d[1]
    const tagExtent = d3.extent([...this.tagAll.map(xAccessor)])

    const yScale = d3
        .scaleLinear()
        .domain(tagExtent)
        .range([this.dimensions.histogramHeight, 0])
        .nice()

    const xScale = d3
        .scaleLinear()
        .domain([0, this.tagAll.length])
        .range([0, this.dimensions.brushWidth])
        .nice()

    const area = d3
        .area()
        .x((d, i) => xScale(i))
        .y0(yScale(0))
        .y1(d => yScale(d[1]))

    // BRUSH
    const brush = d3.select("#brush")
    let x = -1 * this.dimensions.brushWidth / 2
    let y =
        -1 * this.dimensions.textRadius -
        this.dimensions.margin -
        this.dimensions.histogramMargin

    brush
        .style("transform", `translate(${x}px, ${y}px)`)
        .append("line")
        .attr("x1", 0)
        .attr("y1", this.dimensions.histogramHeight + 4)
        .attr("x2", this.dimensions.brushWidth)
        .attr("y2", this.dimensions.histogramHeight + 4)
        .attr("class", "brush-line")
        .attr("stroke", this.colors.grey)
        .attr("stroke-width", 1)

    brush
        .append("text")
        .text("Tag Selection")
        .attr("width", 200)
        .attr("height", 24)
        .attr("y", -10)
        .attr("class", "controllabel")
        

    brush
        .append("path")
        .datum(this.tagAll)
        .attr("fill", this.colors.slider)
        .attr("opacity", this.colors.sliderOpacity)
        .attr("d", area)

    const brushWidth = this.dimensions.arcRadius * 2

    this.brushArea = d3
        .brushX()
        .extent([[0, 0], [brushWidth, this.dimensions.histogramHeight + 3]])
        .on("brush", () => {
            brushDrawing(this)
        })

    brush.attr("class", "brush").call(this.brushArea)

    this.brushArea.move(d3.select(".brush"), [
        xScale(this.startIndex),
        ((this.dimensions.arcRadius * 2) / this.tagAll.length) * this.topTags + xScale(this.startIndex)
    ])

    function brushDrawing(obj) {

        // remove Tooltip if exist
        if (obj.tagClicked > -1) {
            obj.hideToolTip()
        }
        
        d3.getEvent = () => require("d3-selection").event
        const brushPoint = d3.getEvent().selection
        obj.brushPoint = [
            brushPoint[0],
            ((obj.dimensions.arcRadius * 2) / obj.tagAll.length) * obj.topTags +
                brushPoint[0]
        ]

        // clear previous events
        clearTimeout(obj.brushTimerId)

        // schedule new event
        if (obj.brushTimerId != -1) {
            // avoid redraw on page load
            obj.brushTimerId = setTimeout(
                () => executeBrush(obj, brushPoint),
                300
            )
        } else {
            obj.brushTimerId = 0
        }
    }
    function executeBrush(obj, brushPoint) {
        obj.brushTimerId = -1

        const index = Math.round(xScale.invert(brushPoint[0]))
        obj.startIndex = index

        let locStorage = JSON.parse(localStorage.getItem("d3_tag"))
        locStorage.settings.startIndex = index
        window.localStorage.setItem("d3_tag", JSON.stringify(locStorage))

        obj.updateTags(obj.topTags)
        
    }
}

export default createBrush

export function resizeBrush() {
    this.brushArea.move(d3.select(".brush"), [
        this.brushPoint[0],
        this.brushPoint[1]
    ])

    this.brushTimerId != -1
}
